import React, { FC, ReactNode } from 'react'

export const LandDevelopmentPotentialHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/dbb6c5e946ccbd3034dd221127718ddb_Condition.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/cd9345803ebc7bdf9a98a4483a5a6580_Condition@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/6642d16cac41e95e28d5b76afa992362_Condition@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/dbb6c5e946ccbd3034dd221127718ddb_Condition.png'
        }
        width={80}
        height={76}
        alt={''}
      />
    </div>
  )
}
